export const SYSTEM_INIT_SAGA = "SYSTEM_INIT_SAGA";
export const SYSTEM_INITIALIZED = "SYSTEM_INITIALIZED";
